import { h } from 'preact';
export const Trash2 = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polyline", { points: "3 6 5 6 21 6" }),
        h("path", { d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" }),
        h("line", { x1: "10", y1: "11", x2: "10", y2: "17" }),
        h("line", { x1: "14", y1: "11", x2: "14", y2: "17" })));
};
//# sourceMappingURL=trash-2.js.map